import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { FetcherService } from './fetcher/fetcher.service';

import {
  GetCategoryRecommendationData,
  GetCategoryRecommendationsResponsePayload,
} from '@cpak/adp-cpak-bff-service-models';

@Injectable({
  providedIn: 'root',
})
export class RecommendedProductsService {
  constructor(private fetcher: FetcherService) {}

  public getCategoryRecommendationDataExceptProducts(
    data: GetCategoryRecommendationData,
    productIds: string[]
  ): GetCategoryRecommendationData {
    return {
      ...data,
      products: data.products.filter(product => !productIds.includes(product.id)),
      categoryRecommendations: data.categoryRecommendations
        .map(catRec => {
          return {
            ...catRec,
            productIds: catRec.productIds.filter(productId => !productIds.includes(productId)),
          };
        })
        .filter(catRec => catRec.productIds.length),
    };
  }

  public getRecommendedProductsList(
    categories: string[],
    countryId: string,
    quoteProductId?: string,
    locationType?: string
  ): Observable<GetCategoryRecommendationsResponsePayload | null> {
    const defaultParams = { countryIds: countryId };
    let extendedParams: typeof defaultParams & { [key: string]: string | number } = { ...defaultParams };

    if (quoteProductId) {
      extendedParams['quoteProductId'] = quoteProductId;
    }

    if (locationType) {
      extendedParams['locationType'] = locationType;
    }
    return this.fetcher.post(`/api/pages/catalog/categories/recommendations`, { ids: categories }, extendedParams);
  }
}
